import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalStyles } from './GlobalStyles';
import { Layout } from './components/Layout';
import { Gallery } from './pages/Gallery';
import { Home } from './pages/Home';
import { Characters } from './pages/Characters';

function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Gallery />} />
          <Route path="/characters" element={<Characters />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
